module.exports = "https://cdn.hellotech.com/client-assets/computers_desktop_e4fa22014c8d15201e590a803b75e570.png";